import * as tslib_1 from "tslib";
export function createIcon(icon) {
    return tslib_1.__assign({}, icon, { component: 'font-awesome-icon', props: { icon: icon } });
}
//# sourceMappingURL=createIcon.js.map